import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { priceLists } from "../data/priceList";

export default function ListeDePrix() {
  const { language } = useLanguage();
  const page = priceLists[language] || priceLists.fr;

  if (!page?.sections) return null;

  return (
    <section className="pt-32 md:pt-28 pb-24 bg-[#0b1c2d] text-white">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <header className="text-center mb-8">
          <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight text-white">{page.title}</h1>
        </header>

        <div className="space-y-6">
          {page.sections.map((section) => (
            <section
              id={section.id}
              key={section.id}
              className="rounded-2xl border border-white/10 bg-[#10263f] shadow-sm overflow-hidden"
            >
              <div className="px-6 py-4 border-b border-white/10">
                <h2 className="text-lg sm:text-xl font-semibold text-white">{section.heading}</h2>
              </div>

              <div className="divide-y divide-white/10">
                {section.rows.map((row, index) => (
                  <div key={`${section.id}-${index}`} className="px-6 py-4">
                    <div className="text-slate-100">{row.service}</div>
                    {row.note ? <div className="mt-1 text-sm leading-relaxed text-slate-300">{row.note}</div> : null}
                    {row.price ? <div className="text-white font-semibold mt-2">{row.price}</div> : null}
                  </div>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </section>
  );
}
